export default __webpack_public_path__ + "static/tshirts/tshirt-2-a844236911b37816b0a180479324cd99.jpg";